import React from 'react';

const Datenschutz = () => {
  return (
    <div className="min-h-[calc(100vh-200px)] py-10 px-5 bg-slate-100 dark:bg-slate-900">
      <div className="max-w-4xl mx-auto bg-white dark:bg-slate-800 p-6 sm:p-10 rounded-lg shadow-md">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 dark:text-white mb-8 pb-3 border-b-[3px] border-gold">
          Datenschutzerklarung
        </h1>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            1. Datenschutz auf einen Blick
          </h2>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Allgemeine Hinweise
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die folgenden Hinweise geben einen einfachen Uberblick daruber, was mit Ihren personenbezogenen Daten
            passiert, wenn Sie diese Website besuchen und unsere Turnierverwaltung nutzen. Personenbezogene Daten
            sind alle Daten, mit denen Sie personlich identifiziert werden konnen. Ausfuhrliche Informationen zum
            Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgefuhrten Datenschutzerklarung.
          </p>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Datenerfassung auf dieser Website
          </h3>
          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Wer ist verantwortlich fur die Datenerfassung auf dieser Website?
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
            konnen Sie dem Impressum dieser Website entnehmen.
          </p>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Wie erfassen wir Ihre Daten?
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um
            Daten handeln, die Sie bei der Registrierung, bei der Turnieranmeldung oder bei der Eingabe von
            Spielergebnissen angeben.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor
            allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
            Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
          </p>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Wofur nutzen wir Ihre Daten?
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Daten werden erhoben, um die Turnierverwaltung durchzufuhren, Spielplane zu erstellen, Ergebnisse
            zu verarbeiten und Ranglisten zu generieren. Ein Teil der Daten wird ausserdem erhoben, um eine
            fehlerfreie Bereitstellung der Website zu gewahrleisten.
          </p>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Welche Rechte haben Sie bezuglich Ihrer Daten?
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Sie haben jederzeit das Recht, unentgeltlich Auskunft uber Herkunft, Empfanger und Zweck Ihrer
            gespeicherten personenbezogenen Daten zu erhalten. Sie haben ausserdem ein Recht, die Berichtigung
            oder Loschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
            konnen Sie diese Einwilligung jederzeit fur die Zukunft widerrufen. Ausserdem haben Sie das Recht, unter
            bestimmten Umstanden die Einschrankung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            Des Weiteren steht Ihnen ein Beschwerderecht bei der zustandigen Aufsichtsbehorde zu.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Hierzu sowie zu weiteren Fragen zum Thema Datenschutz konnen Sie sich jederzeit unter der im Impressum
            angegebenen Adresse an uns wenden.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            2. Hosting
          </h2>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Externes Hosting
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden,
            werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v.a. um IP-Adressen,
            Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Turnierdaten,
            Spielergebnisse, Websitezugriffe und sonstige Daten, die uber eine Website generiert werden, handeln.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Das externe Hosting erfolgt zum Zwecke der Vertragserfullung gegenuber unseren potenziellen und
            bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und
            effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter
            (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfullung seiner Leistungspflichten
            erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            3. Registrierung und Nutzerkonto
          </h2>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Benutzerkonto fur Turnierverwaltung
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Fur die Nutzung bestimmter Funktionen dieser Website (insbesondere fur die Verwaltung von Turnieren
            und die Eingabe von Ergebnissen) konnen Sie ein Benutzerkonto erstellen. Die Registrierung erfolgt
            durch einen Administrator.
          </p>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Welche Daten werden bei der Registrierung erhoben?
          </h4>
          <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 leading-relaxed mb-3 ml-4">
            <li>Benutzername</li>
            <li>E-Mail-Adresse</li>
            <li>Passwort (verschlusselt gespeichert)</li>
            <li>Rolle/Berechtigungsstufe (z.B. Turnier-Admin, Vollstandiger Admin)</li>
          </ul>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Zweck und Rechtsgrundlage
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Verarbeitung dieser Daten erfolgt zur Bereitstellung des Benutzerkontos und der damit verbundenen
            Funktionen (Turnierverwaltung, Ergebniseingabe, Verwaltung von Spielern und Teams). Die Rechtsgrundlage
            ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfullung bzw. vorvertragliche Massnahmen).
          </p>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Speicherdauer
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Daten werden gespeichert, solange das Benutzerkonto aktiv ist. Nach Loschung des Kontos werden die
            personlichen Zugangsdaten geloscht. Turnierdaten und Ergebnisse, die wahrend der Nutzung erstellt wurden,
            konnen aus rechtlichen und organisatorischen Grunden weiterhin gespeichert bleiben (siehe Abschnitt
            "Turnierdaten und Ergebnisse").
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            4. Turnierdaten und Ergebnisse
          </h2>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Erfassung von Spieler- und Teaminformationen
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Im Rahmen der Turnierverwaltung werden folgende personenbezogene Daten von Teilnehmern erfasst:
          </p>
          <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 leading-relaxed mb-3 ml-4">
            <li>Namen der Spieler/innen</li>
            <li>Teamnamen und Teamzusammensetzungen</li>
            <li>Gruppenzuordnungen</li>
            <li>Spielergebnisse und Statistiken</li>
            <li>Platzierungen und Ranglisten</li>
          </ul>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Zweck der Datenverarbeitung
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Diese Daten werden zur Durchfuhrung und Organisation von Padel-Turnieren verarbeitet, insbesondere zur:
          </p>
          <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 leading-relaxed mb-3 ml-4">
            <li>Erstellung von Spielplanen und Turnierbaumen</li>
            <li>Verwaltung von Gruppenphasen und K.O.-Runden</li>
            <li>Erfassung und Anzeige von Spielergebnissen</li>
            <li>Berechnung von Statistiken und Ranglisten</li>
            <li>Veroffentlichung von Turnierergebnissen</li>
          </ul>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Rechtsgrundlage
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Durchfuhrung des Turniers als
            vertragliche bzw. quasi-vertragliche Leistung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
            an der Organisation und Durchfuhrung von Sportturnieren).
          </p>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Offentliche Anzeige von Turnierdaten
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Turnierergebnisse, Spielplane und Ranglisten werden offentlich auf dieser Website angezeigt. Dies umfasst:
          </p>
          <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 leading-relaxed mb-3 ml-4">
            <li>Namen der Spieler/innen in Spielpaarungen und Ranglisten</li>
            <li>Teamnamen und Teamzusammensetzungen</li>
            <li>Spielergebnisse (Punkte, Satze, Games)</li>
            <li>Gruppentabellen mit Statistiken (Siege, Niederlagen, Punkten)</li>
            <li>K.O.-Runden-Paarungen und Platzierungsspiele</li>
          </ul>

          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Veroffentlichung dieser Daten erfolgt im offentlich zuganglichen Bereich der Website, ohne dass
            eine Anmeldung erforderlich ist. Dies dient der Transparenz des Turnierverlaufs und entspricht den
            Erwartungen der Teilnehmer/innen an einem offentlichen Sportturnier.
          </p>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Widerspruchsmoglichkeit
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Wenn Sie einer Veroffentlichung Ihres Namens in Zusammenhang mit Turnierergebnissen widersprechen
            mochten, konnen Sie uns unter der im Impressum angegebenen E-Mail-Adresse kontaktieren. Wir werden
            Ihren Namen dann durch eine Anonymisierung (z.B. Initialen oder Pseudonym) ersetzen, soweit dies
            technisch und organisatorisch moglich ist.
          </p>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Speicherdauer
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Turnierdaten werden wie folgt gespeichert:
          </p>
          <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 leading-relaxed mb-3 ml-4">
            <li>
              <strong>Aktuelle Turniere:</strong> Vollstandige Daten bleiben wahrend des laufenden Turniers
              und fur 12 Monate nach Turnierbeendigung offentlich einsehbar.
            </li>
            <li>
              <strong>Vergangene Turniere:</strong> Nach 12 Monaten werden Turniere als "vergangene Turniere"
              archiviert und bleiben weiterhin offentlich zuganglich, um eine langfristige Dokumentation der
              Turnierergebnisse zu ermoglichen.
            </li>
            <li>
              <strong>Loschung:</strong> Turnierdaten werden auf Anfrage oder nach 5 Jahren anonymisiert oder
              geloscht, es sei denn, es bestehen gesetzliche Aufbewahrungspflichten.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            5. Cookies und ahnliche Technologien
          </h2>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Technisch notwendige Cookies
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Diese Website verwendet Cookies und ahnliche Technologien (wie LocalStorage), die fur den Betrieb
            der Website technisch notwendig sind. Diese Technologien ermoglichen grundlegende Funktionen wie:
          </p>
          <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 leading-relaxed mb-3 ml-4">
            <li>Speicherung der Anmeldeinformationen (Login-Token) fur eingeloggte Benutzer</li>
            <li>Aufrechterhaltung der Session wahrend der Nutzung der Website</li>
            <li>Speicherung von temporaren Einstellungen und Navigationszustanden</li>
          </ul>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Art und Umfang der gespeicherten Daten
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Folgende Daten werden lokal im Browser gespeichert:
          </p>
          <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 leading-relaxed mb-3 ml-4">
            <li>
              <strong>Authentication Token:</strong> Ein verschlusselter Token zur Authentifizierung eingeloggter
              Benutzer. Dieser wird nach dem Login im LocalStorage des Browsers gespeichert und bei jeder
              Anfrage an den Server mitgeschickt.
            </li>
          </ul>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Rechtsgrundlage
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Verwendung technisch notwendiger Cookies und LocalStorage erfolgt auf Grundlage von Art. 6 Abs. 1
            lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung dieser Daten,
            um eine ordnungsgemasse Funktion der Website und insbesondere der Login-Funktionalitat zu gewahrleisten.
          </p>

          <h4 className="text-base font-medium text-slate-600 dark:text-slate-300 mb-2 mt-4">
            Speicherdauer
          </h4>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Der Authentication Token bleibt im Browser gespeichert, bis Sie sich ausloggen oder der Token ablauft.
            Sie konnen den Token jederzeit durch Logout oder durch Loschen der Browser-Daten entfernen.
          </p>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Keine Analyse- oder Marketing-Cookies
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Diese Website verwendet derzeit keine Cookies oder ahnliche Technologien zu Analyse-, Marketing- oder
            Tracking-Zwecken. Es werden keine Daten an Drittanbieter wie Google Analytics, Facebook oder ahnliche
            Dienste ubermittelt.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            6. Allgemeine Hinweise und Pflichtinformationen
          </h2>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Datenschutz
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer personlichen Daten sehr ernst. Wir behandeln Ihre
            personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie
            dieser Datenschutzerklarung.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene
            Daten sind Daten, mit denen Sie personlich identifiziert werden konnen. Die vorliegende
            Datenschutzerklarung erlautert, welche Daten wir erheben und wofur wir sie nutzen. Sie erlautert auch,
            wie und zu welchem Zweck das geschieht.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Wir weisen darauf hin, dass die Datenubertragung im Internet (z.B. bei der Kommunikation per E-Mail)
            Sicherheitslucken aufweisen kann. Ein luckenloser Schutz der Daten vor dem Zugriff durch Dritte ist
            nicht moglich.
          </p>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Hinweis zur verantwortlichen Stelle
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die verantwortliche Stelle fur die Datenverarbeitung auf dieser Website ist:
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Timm Buse<br />
            E-Mail: info@tmk-it.de
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Verantwortliche Stelle ist die naturliche oder juristische Person, die allein oder gemeinsam mit anderen
            uber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. A.)
            entscheidet.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            7. Datenerfassung auf dieser Website
          </h2>

          <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-3 mt-5">
            Server-Log-Dateien
          </h3>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien,
            die Ihr Browser automatisch an uns ubermittelt. Dies sind:
          </p>
          <ul className="list-disc list-inside text-slate-600 dark:text-slate-300 leading-relaxed mb-3 ml-4">
            <li>Browsertyp und Browserversion</li>
            <li>verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Eine Zusammenfuhrung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat
            ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website -
            hierzu mussen die Server-Log-Files erfasst werden.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-4 mt-6">
            8. Kontaktaufnahme
          </h2>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben aus der Anfrage inklusive der von Ihnen dort
            angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und fur den Fall von Anschlussfragen bei uns
            gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
            mit der Erfullung eines Vertrags zusammenhangt oder zur Durchfuhrung vorvertraglicher Massnahmen
            erforderlich ist. In allen ubrigen Fallen beruht die Verarbeitung auf unserem berechtigten Interesse an
            der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
            Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
          </p>
          <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-3">
            Die von Ihnen an uns per Kontaktanfragen ubersandten Daten verbleiben bei uns, bis Sie uns zur Loschung
            auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck fur die Datenspeicherung entfallt
            (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen - insbesondere
            gesetzliche Aufbewahrungsfristen - bleiben unberuhrt.
          </p>
        </section>

        <section className="mb-8">
          <p className="text-sm text-slate-500 dark:text-slate-400 italic">
            Quelle: Teilweise basierend auf Vorlagen von{' '}
            <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">
              e-recht24.de
            </a>,
            angepasst und erweitert fur die spezifischen Anforderungen dieser Turnierverwaltungs-Plattform.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Datenschutz;
